import * as React from 'react';
import styled, { css } from 'styled-components';
import { Input } from '../input/newInput/NewInput';
import { InputType } from '../input/newInput/models';
import { texts } from './consts';
import { MutableRefObject, useMemo, useRef } from 'react';

// ############################ Styles ###########################
// tslint:disable-next-line:variable-name
const SErrorWrapper = styled.div<{ error: boolean | string | undefined }>(({ theme, error }) => {
  return {
    borderRadius: theme.borderRadiusCommon,
    width: '100%',
  };
});

const SEditButton = styled.p(
  ({ theme }) => css`
    cursor: pointer;
    padding: 0 10px;
    // Override the Input disable text color
    -webkit-text-fill-color: ${theme.colors.primaryBright};
    font-weight: 600;
  `
);

const SAnimatedInput = styled.div<{ blue: boolean }>(
  ({ theme, blue }) => css`
    position: relative;

    & label::before {
      font-size: ${theme.font.size.smallMedium};
      font-family: Poppins;
      color: ${theme.colors.placeholderGray};
      font-weight: ${theme.font.weight.medium};
    }

    & input {
      font-weight: ${theme.font.weight.medium};
      color: ${theme.colors.primaryBackground};
      background: ${blue ? 'white' : '#f6f6f6'};
      font-family: Poppins;
      border-color: transparent;
    }
  `
);

// tslint:enable:variable-name
// ############################ End Styles ###########################

export interface IInputValueProps {
  error?: string;
  label?: string;
  name?: string;
  dataAt?: string;
  disabled?: boolean;
  autoComplete?: string;
  type?: InputType;
  onClick?: () => void;
  onChange?: (event: any) => void;
  onFocus?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onKeyEnter?: () => void;
  inputType?: string;
  autoFocus?: boolean;
  value?: string;
  className?: string;
  maxLength?: number;
  animatedLabel?: string;
  isLogin?: boolean;
  backgroundColor?: string;
  pattern?: string;
  children?: JSX.Element | JSX.Element[];
  padding?: number;
  blue?: boolean;
  isSecuredInput?: boolean;
  onSubmit?: () => void;
  inputRef?: MutableRefObject<HTMLInputElement | null>;
  popupMode?: boolean;
  minWidth?: string;
  dataTestId?: string;
  inputDataTestId?: string;
  placeholder?: string;
  initErrorSpacing?: boolean;
  isAnimated?: boolean;
  hidePlaceholderAsTitle?: boolean;
}

// tslint:disable-next-line: variable-name
const AnimatedInput: React.FC<IInputValueProps> = ({
  value,
  name,
  dataAt,
  error,
  // inputType: type = InputType.Text,
  inputType = InputType.Text,
  // tslint:disable-next-line: no-empty
  onChange = () => {},
  // tslint:disable-next-line: no-empty
  onFocus = () => {},
  // tslint:disable-next-line: no-empty
  onBlur = () => {},
  // tslint:disable-next-line: no-empty
  onKeyEnter = () => {},
  // tslint:disable-next-line: no-empty
  onClick = () => {},
  autoFocus = false,
  label,
  animatedLabel = '',
  maxLength,
  className,
  isLogin = false,
  backgroundColor = 'transparent',
  pattern = '',
  children,
  padding = 0,
  blue,
  isSecuredInput = false,
  disabled,
  onSubmit,
  popupMode = false,
  minWidth = 'inherit',
  inputRef: parentInputRef,
  dataTestId,
  inputDataTestId,
  initErrorSpacing,
  placeholder,
  isAnimated = true,
  hidePlaceholderAsTitle,
}) => {
  const inputRef = parentInputRef || useRef<HTMLInputElement>();

  const button = useMemo(() => {
    if (popupMode) {
      return <SEditButton {...{ onClick }}>{texts.EDIT_BUTTON}</SEditButton>;
    }
  }, [popupMode, onClick]);

  const inputProps = {
    onSubmit,
    name,
    dataAt,
    type: inputType as InputType,
    label,
    animatedLabel,
    maxLength,
    onFocus,
    onBlur,
    isLogin,
    backgroundColor,
    pattern,
    autoFocus,
    padding,
    blue,
    isSecuredInput,
    isAnimated: isAnimated,
    onKeyEnter,
    value,
    innerRef: inputRef,
    button,
    onChange,
    onClick,
    error,
    minWidth,
    initErrorSpacing,
    dataTestId: inputDataTestId,
    placeholder,
    hidePlaceholderAsTitle,
  };

  // @ts-ignore
  return (
    <SAnimatedInput {...{ className, blue, 'data-testid': dataTestId }} style={{ padding, minWidth }}>
      {children ? (
        children
      ) : (
        <SErrorWrapper error={error}>
          <Input {...{ ...inputProps, disabled: disabled || !!popupMode, className: 'input' }} />
        </SErrorWrapper>
      )}
    </SAnimatedInput>
  );
};

export default AnimatedInput;
